import { fetchWrapper } from '@/helpers/fetch-wrapper';
import { ref } from 'vue';
const baseUrl = `${import.meta.env.VITE_API_URL}`;

const authService = {
  verifyAndUpdateToken: () => {
    return fetchWrapper.get(`${baseUrl}/verify-and-update-token`, null, null);
  },
  getGrupoUser(){
    const groupsUser = ref(null);

    function getCookie(name) {
      let cookies = document.cookie.split("; ");
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i];
        let [cookieName, cookieValue] = cookie.split("=");
        if (cookieName === name) {
          return decodeURIComponent(cookieValue);
        }
      }
      return null;
    }
    const groupsCookie = getCookie("groups");
    if (!groupsCookie) {
      console.warn("Cookie 'groups' não encontrado.");
      return null;
    }
    try {
      const decodedToken = JSON.parse(atob(groupsCookie));
      const messageData = JSON.parse(decodedToken.message);
      groupsUser.value = messageData.join().replace(/\//g, "");
    } catch (error) {
      return null;
    }
    return groupsUser.value;
  }
};

export default authService;
